import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../../core/img/ImageWithBasePath";

const icons = [
  { class: "fa-wrench", color: "#00AEEF" },
  { class: "fa-cogs", color: "#FF7F50" },
  { class: "fa-hammer", color: "#FFD700" },
  { class: "fa-toolbox", color: "#32CD32" },
  { class: "fa-plug", color: "#FF4500" },
  { class: "fa-screwdriver", color: "#1E90FF" }
];

const FloatingIcons = () => {
  const [positions, setPositions] = useState(
    icons.map(() => ({
      x: Math.random() * 80 + 10 + "%",
      y: Math.random() * 80 + 10 + "%"
    }))
  );

  useEffect(() => {
    // No need to handle mouse movement anymore
  }, []);

  return (
    <>
      {positions.map((pos, index) => (
        <i
          key={index}
          className={`fa ${icons[index].class} floating-icon`}
          style={{
            left: pos.x,
            top: pos.y,
            color: icons[index].color,
            animation: `shake ${Math.random() * 2 + 4}s infinite alternate ease-in-out`,
            zIndex: 1000,
          }}
        />
      ))}
    </>
  );
};

const BussinessWithUs = () => {
  return (
    <>
      <section
        id="business-section"
        className="section business-section position-relative overflow-hidden"
        style={{
          backgroundColor: "black",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <FloatingIcons />
        <div className="container position-relative">
          <div className="row align-items-center glassmorphism-effect">
            <div className="col-md-6 wow fadeInUp" data-wow-delay="0.2s">
              <div className="section-header mb-md-0 mb-4">
                <h2 className="text-white display-4">
                  Service &amp; Grow your <span className="text-linear-primary"> Delivery with us</span>
                </h2>
                <p className="text-light">
                  We provide top-quality service, ensuring customer satisfaction.
                </p>
                <Link to="#" className="btn btn-linear-primary">
                  <i className="ti ti-user-filled me-2" />
                  Join Us
                </Link>
              </div>
            </div>
            <div className="col-md-6 text-md-end wow fadeInUp" data-wow-delay="0.2s">
              <div className="business-img">
                <ImageWithBasePath
                  src="assets/img/Banner-Tech02.png"
                  className="img-fluid"
                  alt="img"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <style>
  {`
    #business-section {
      position: relative;
      overflow: hidden;
    }
    .floating-icon {
      position: absolute;
      font-size: 2rem;
      opacity: 0.8;
      animation: shake 5s infinite alternate ease-in-out;
      transition: transform 0.2s ease-out;
      pointer-events: none;
    }

    @keyframes shake {
      0% { transform: translateX(0px) translateY(0px) rotate(0deg); }
      25% { transform: translateX(10px) translateY(0px) rotate(5deg); }
      50% { transform: translateX(-10px) translateY(0px) rotate(-5deg); }
      75% { transform: translateX(5px) translateY(5px) rotate(3deg); }
      100% { transform: translateX(0px) translateY(0px) rotate(0deg); }
    }

    /* Glassmorphism Effect */
    .glassmorphism-effect {
      background: rgba(0, 108, 231, 0.52); /* Semi-transparent black */
      backdrop-filter: blur(10px);
      border-radius: 15px;
      padding: 30px;
    }

    /* Hide floating icons on screens smaller than 768px */
    @media (max-width: 768px) {
      .floating-icon {
        display: none;
      }
    }
  `}
</style>
    </>
  );
};

export default BussinessWithUs;
